import { notification } from "antd"
import axios from "axios"
import { API_BASE_URL } from "configs/AppConfig"
import { AUTH_TOKEN } from "constants/AuthConstant"
import store from "store"
import { refresh, signOut } from "store/slices/authSlice"

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  // withCredentials: true,
})
// Config
const TOKEN_PAYLOAD_KEY = "Authorization"

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN)

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`
    }

    return config
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
      description: "An error occurred while making the request.",
      type: "error",
    })
    return Promise.reject(error)
  },
)

// API response interceptor
service.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const prevRequest = error?.config

    if (error?.response) {
      const isRefreshRequest = prevRequest?.url?.includes("/auth/refresh-token")

      // 1 Handle access token expiration (first occurrence)
      if (
        error.response.status === 401 &&
        !prevRequest?.sent &&
        error.response.data.message === "Token expired" &&
        !isRefreshRequest
      ) {
        try {
          console.log("Refreshing token....")
          const newAccessToken = await store.dispatch(refresh())
          prevRequest.sent = true
          prevRequest.headers[TOKEN_PAYLOAD_KEY] =
            `Bearer ${newAccessToken.payload}`
          return service(prevRequest) // Retry the original request
        } catch (refreshError) {
          store.dispatch(signOut())
          notification.warning({
            message: "Session error",
            description: "Please login to continue.",
            type: "error",
          })
          return Promise.reject(refreshError)
        }
      }

      // 2 If retry failed (already sent once), log out
      else if (error.response.status === 401 && prevRequest?.sent) {
        store.dispatch(signOut())
        notification.warning({
          message: "Session Expired",
          description: "Please login to continue.",
          type: "info",
        })
      }

      // 3 Forbidden
      else if (error.response.status === 403) {
        notification.warning({
          message: "Forbidden",
          description: "You are not allowed to access this resource.",
          type: "warning",
        })
      }
    }

    return Promise.reject(error)
  },
)

export default service
